/**
 * 文本统计工具
 * 提供文本特征统计和分析功能
 *
 * 核心功能：
 * 1. 字符、词语、句子计数
 * 2. 文本复杂度分析
 */
/**
 * 获取文本的基本统计信息
 * @param text 文本内容
 * @returns 文本统计信息
 */
export function getTextStats(text) {
    if (!text) {
        return { charCount: 0, wordCount: 0, sentenceCount: 0 };
    }
    // 字符数（不包括空白字符）
    const charCount = text.replace(/\s/g, '').length;
    // 粗略估计词数（基于空格分割，适用于西方语言）
    const wordCount = text.split(/\s+/).filter(Boolean).length;
    // 粗略估计句子数（基于常见的句号等）
    const sentenceCount = text.split(/[.!?。！？]+/).filter(Boolean).length;
    return { charCount, wordCount, sentenceCount };
}
//# sourceMappingURL=stats.js.map